import { EntityId, TemporalEntityId } from 'entities-next/common'
import { flow } from 'lodash'
import { getFormFormattedDate, getToday } from 'utils'

import { FundingRound, Investment } from './fundingRound.types'

function getInvestmentEntityName(investment: Investment) {
  if (investment.organization) {
    return investment.organization.name
  } else if (investment.person) {
    return `${investment.person.firstName} ${investment.person.lastName}`
  } else {
    return ''
  }
}

export function getFundingRoundInvestments({ investments }: FundingRound) {
  return investments
}

export function getFundingRoundLeadInvestors(fundingRound: FundingRound) {
  const investments = getFundingRoundInvestments(fundingRound)
  if (!investments || investments.length === 0) {
    return []
  }

  const leadInvestorsNames = investments.filter((investment) => investment.isLead).map(getInvestmentEntityName)

  if (leadInvestorsNames.length > 0) {
    return leadInvestorsNames
  } else {
    return []
  }
}

export function getFundingRoundOtherInvestors(fundingRound: FundingRound) {
  const investments = getFundingRoundInvestments(fundingRound)
  if (!investments || investments.length < 1) {
    return []
  }

  const otherInvestorsNames = investments.filter((investment) => !investment.isLead).map(getInvestmentEntityName)

  if (otherInvestorsNames.length > 0) {
    return otherInvestorsNames
  } else {
    return []
  }
}

export function buildFundingRound(companyId: EntityId): FundingRound {
  return {
    id: TemporalEntityId.new,
    companyId,
    roundType: '',
    announcedOn: flow(getToday, getFormFormattedDate)(),
    roundSize: undefined,
    targetMoney: undefined,
    valuationPreMoney: undefined,
    roundTerms: '',
    committedInvestors: '',
    investments: [],
    createdAt: getToday(),
  }
}

export function buildInvestment(fundingRoundId: EntityId): Investment {
  return {
    id: TemporalEntityId.new,
    fundingRoundId,
    isLead: false,
    createdAt: getToday(),
  }
}
